export function convertCreditCardToPaymentMethod(creditCard) {
  const {
    CardName: cardName,
    ExpDate: expDate,
    CardHolder: cardHolder,
    ID: id,
    Account: account,
  } = creditCard;
  const { FirstName: firstName, LastName: lastName } = cardHolder;
  const expMonth = expDate.substring(0, 2);
  const expYear = expDate.substring(2, 4);

  return {
    card_type: cardName.toUpperCase(),
    expiration: `${expMonth}/${expYear}`,
    expiration_month: expMonth,
    expiration_year: expYear,
    full_name: capitalizeName(`${firstName} ${lastName}`),
    payment_method_token: id,
    last_four: account.slice(-4),
  };
}

function capitalizeName(fullName) {
  return fullName
    .toLowerCase()
    .split(' ')
    .map((name) => {
      return name ? name[0].toUpperCase() + name.slice(1) : '';
    })
    .join(' ');
}
